import {
  IconBell,
  IconGenderFemale,
  IconGenderMale,
  IconMoonStars,
  IconSun,
  IconSunset2,
  IconTicket,
} from "@tabler/icons-react";
import type { IconBaseProps } from "react-icons";
import { BiTimeFive } from "react-icons/bi";
import {
  BsArrowLeftRight,
  BsCardImage,
  BsCheck2Square,
  BsCloudArrowDown,
  BsEnvelopeExclamation,
  BsExclamationCircle,
  BsFiletypePdf,
  BsFillBuildingFill,
  BsFillTrash3Fill,
  BsPaperclip,
  BsQuestionCircle,
} from "react-icons/bs";
import {
  FaAngleDown,
  FaAngleLeft,
  FaAngleRight,
  FaAngleUp,
  FaBook,
  FaCalculator,
  FaCalendarAlt,
  FaExternalLinkAlt,
  FaInfo,
  FaPhoneAlt,
  FaRegEdit,
  FaRegEnvelope,
  FaSearch,
  FaStoreAlt,
  FaUserPlus,
  FaYoutube,
} from "react-icons/fa";
import {
  FaAnglesLeft,
  FaAnglesRight,
  FaCircleCheck,
  FaCirclePause,
  FaCircleUser,
  FaClipboardUser,
  FaFileImage,
} from "react-icons/fa6";
import { HiClipboardList, HiCurrencyYen, HiPlusCircle } from "react-icons/hi";
import {
  MdAccountCircle,
  MdBlock,
  MdCampaign,
  MdClose,
  MdCoPresent,
  MdCurrencyYen,
  MdEditSquare,
  MdLogout,
  MdMenuBook,
  MdMessage,
  MdOutlineQrCode,
  MdOutlineWork,
  MdPunchClock,
  MdStore,
  MdThumbDownOffAlt,
  MdThumbUpOffAlt,
} from "react-icons/md";
import {
  PiHouseBold,
  PiThumbsUpFill,
  PiUserBold,
  PiUserListLight,
} from "react-icons/pi";
import { SiLine } from "react-icons/si";

type Props = IconBaseProps;

const iconDefaultOption = {
  size: "1rem",
};

export function ClipboardUserIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaClipboardUser {...option} />;
}

export function ThumbsUpFillIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <PiThumbsUpFill {...option} />;
}

export function StoreAltIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaStoreAlt {...option} />;
}

export function QuestionCircleIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsQuestionCircle {...option} />;
}

export function CloudArrowDownIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsCloudArrowDown {...option} />;
}

export function CardImageIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsCardImage {...option} />;
}

export function TicketIcon(props: Props) {
  const { size = iconDefaultOption.size, color, style, className } = props;
  return (
    <IconTicket
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-hidden
    />
  );
}

export function BellIcon(props: Props) {
  const { size = iconDefaultOption.size, color, style, className } = props;
  return (
    <IconBell
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-hidden
    />
  );
}

export function Check2Square(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsCheck2Square {...option} />;
}

export function EnvelopeExclamationIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsEnvelopeExclamation {...option} />;
}

export function ExclamationCircleIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsExclamationCircle {...option} />;
}

export function OutlineQrCodeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdOutlineQrCode {...option} />;
}

export function MessageIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdMessage {...option} />;
}

export function ClipboardListIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <HiClipboardList {...option} />;
}

export function PlusCircleIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <HiPlusCircle {...option} />;
}

export function UserBoldIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <PiUserBold {...option} />;
}

export function UserListLightIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <PiUserListLight {...option} />;
}

export function HiCurrencyYenIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <HiCurrencyYen {...option} />;
}

export function FillBuildingFillIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsFillBuildingFill {...option} />;
}

export function StoreIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdStore {...option} />;
}

export function LeftRightIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsArrowLeftRight {...option} />;
}

export function CloseIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdClose {...option} />;
}

export function ArrowLeft(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaAngleLeft {...option} />;
}

export function ArrowRight(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaAngleRight {...option} />;
}

export function ArrowDown(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaAngleDown {...option} />;
}
export function ArrowUp(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaAngleUp {...option} />;
}

export function EditIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaRegEdit {...option} />;
}

export function WorkIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdOutlineWork {...option} />;
}

export function WorkEditIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdEditSquare {...option} />;
}

export function EmployeesIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdCoPresent {...option} />;
}

export function AccountIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdAccountCircle {...option} />;
}

export function PunchClockIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdPunchClock {...option} />;
}

export function LogoutIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdLogout {...option} />;
}

export function GoodIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdThumbUpOffAlt {...option} />;
}

export function BadIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdThumbDownOffAlt {...option} />;
}
export function HouseIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <PiHouseBold {...option} />;
}

export function TimeFiveIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BiTimeFive {...option} />;
}

export function YenIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdCurrencyYen {...option} />;
}

export function BookIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaBook {...option} />;
}

export function InfoIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaInfo {...option} />;
}

export function PdfIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsFiletypePdf {...option} />;
}

export function FollowIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaUserPlus {...option} />;
}

export function BlockIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdBlock {...option} />;
}
export function MenuBookIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdMenuBook {...option} />;
}
export function SearchIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaSearch {...option} />;
}

export function CircleUserIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCircleUser {...option} />;
}
export function CirclePauseIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCirclePause {...option} />;
}
export function CircleCheckIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCircleCheck {...option} />;
}

export function ChevronRightIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaAnglesRight {...option} />;
}

export function ChevronLeftIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaAnglesLeft {...option} />;
}

export function CampaignIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <MdCampaign {...option} />;
}

export function CalculatorIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCalculator {...option} />;
}

export function FileImageIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaFileImage {...option} />;
}

export function AttachIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsPaperclip {...option} />;
}

export function TrashIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <BsFillTrash3Fill {...option} />;
}

export function YoutubeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaYoutube {...option} />;
}

export function CalendarAltIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaCalendarAlt {...option} />;
}

export function ExternalLinkAltIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaExternalLinkAlt {...option} />;
}

export function PhoneAltIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaPhoneAlt {...option} />;
}

export function RegEnvelopeIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <FaRegEnvelope {...option} />;
}

export function LineIcon(props: Props) {
  const { ...iconProps } = props;
  const defaultOption: IconBaseProps = {
    ...iconDefaultOption,
  };
  const option = Object.assign({}, defaultOption, iconProps);
  return <SiLine {...option} />;
}

export function DayShiftIcon(props: Props) {
  const {
    size = iconDefaultOption.size,
    color,
    style,
    className,
    "aria-label": ariaLabel,
  } = props;
  return (
    <IconSun
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
}

export function EveningShiftIcon(props: Props) {
  const {
    size = iconDefaultOption.size,
    color,
    style,
    className,
    "aria-label": ariaLabel,
  } = props;
  return (
    <IconSunset2
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
}

export function NightShiftIcon(props: Props) {
  const {
    size = iconDefaultOption.size,
    color,
    style,
    className,
    "aria-label": ariaLabel,
  } = props;
  return (
    <IconMoonStars
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
}

export function MaleIcon(props: Props) {
  const {
    size = iconDefaultOption.size,
    color,
    style,
    className,
    "aria-label": ariaLabel,
  } = props;
  return (
    <IconGenderMale
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
}

export function FemaleIcon(props: Props) {
  const {
    size = iconDefaultOption.size,
    color,
    style,
    className,
    "aria-label": ariaLabel,
  } = props;
  return (
    <IconGenderFemale
      size={size}
      color={color}
      stroke={2.5}
      style={style}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
}
